import { Grid } from "@material-ui/core";
import moment from "moment";
import { FunctionComponent } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Button } from "../../../../components/button";
import { useHasPermission } from "../../../../components/permission";
import { AuthActions } from "../../../../store/auth/actions";
import { countries } from "../../../../store/common/models";
import { UsersDTO } from "../../../../store/users/models/dto";
import { Label, StyledWidget } from "../common/components";

const CTA = styled(Button)`
  display: inline-block;
  & + & {
    margin-left: 1em;
  }
`;

export const DelegateOverview: FunctionComponent<{
  item: UsersDTO.Responses.GetSingle.T;
}> = ({ item }) => {
  const {
    emailAddress,
    createdDate,
    username,
    firstName,
    middleName,
    lastName,
    dateOfBirth,
    nationality,
    level,
    believer,
  } = item;

  const dispatch = useDispatch();
  const detailed = useHasPermission(["ROLE_ADMIN"]);

  return (
    <StyledWidget
      title="User Overview"
      adornment={
        detailed ? (
          <>
            <CTA
              onClick={() =>
                dispatch(AuthActions.impersonateRequest({ username }))
              }
            >
              Impersonate
            </CTA>
          </>
        ) : null
      }
    >
      <Grid container spacing={3}>
        <Grid item lg={6} xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Label>Name:</Label>
            </Grid>
            <Grid item xs={6}>
              {firstName} {middleName} {lastName}
            </Grid>
            <Grid item xs={6}>
              <Label>Email:</Label>
            </Grid>
            <Grid item xs={6}>
              {emailAddress}
            </Grid>
            <Grid item xs={6}>
              <Label>Nationality:</Label>
            </Grid>
            <Grid item xs={6}>
              {countries.enum[nationality as typeof countries.T]}
            </Grid>
            <Grid item xs={6}>
              <Label>Username:</Label>
            </Grid>
            <Grid item xs={6}>
              {username}
            </Grid>
            <Grid item xs={6}>
              <Label>Date of Birth:</Label>
            </Grid>
            <Grid item xs={6}>
              {moment.utc(dateOfBirth).local().format("yyyy-MM-DD")}
            </Grid>
            <Grid item xs={6}>
              <Label>Levels:</Label>
            </Grid>
            <Grid item xs={6}>
              {level} {believer ? "+ Believer" : ""}
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={6} xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Label>Date Created:</Label>
            </Grid>
            <Grid item xs={6}>
              {moment.utc(createdDate).local().format("yyyy-MM-DD HH:mm")}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </StyledWidget>
  );
};
